import React from 'react';
import { Channel } from './types';
import Launch from './Launch';

type Props = {
    finncode: number | string;
    channel: Channel;
    active: boolean
};

class Open extends React.Component<Props> {
    render() {
        const { finncode, channel,active } = this.props;

        const liveUrl = channelUrl(channel);
        return active && (
            <div className="panel" style={{margin:"24px",marginBottom:"24px", paddingBottom:"24px"}}>
                {liveUrl && (
                    <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={liveUrl + '?finncode=' + finncode}
                        className="button button--has-icon"
                    >
                        <Launch />
                        <span
                            style={{
                                paddingLeft: '8px',
                            }}
                        >
                            Se full størrelse i nettleseren
                        </span>
                    </a>
                )}
            </div>
        );
    }
}

export default Open;

function channelUrl(channel: Channel) {
    switch (channel) {
        case 'vg.no':
            return 'https://www.vg.no/';
        case 'ap.no':
            return 'https://www.aftenposten.no/';
        case 'e24':
            return 'https://e24.no/';
        case 'aftenbladet.no':
            return 'https://www.aftenbladet.no/';
        case 'bt.no':
            return 'https://www.bt.no';
        case 'fvn.no':
            return 'https://www.fvn.no/';
        case 'adressa.no':
            return 'https://www.adressa.no/';
        case 'tek':
            return 'https://www.tek.no/';
        default:
            return channel;
    }
}
